export { default } from './BensServicosBanner';
